import { apiClient } from '@/lib/api/client';

export const supportAPI = {
  // User
  createOrGetTicket: (data: { subject?: string; guest_email?: string; guest_name?: string }) =>
    apiClient.post<{ id: number; public_token?: string }>(`/support/tickets`, data).then(r => r.data),
  listMyTickets: (params?: { skip?: number; limit?: number }) =>
    apiClient.get(`/support/tickets`, { params }).then(r => r.data),
  getTicket: (ticketId: number, token?: string) =>
    apiClient.get<{ id: number; public_token?: string; messages: any[] }>(`/support/tickets/${ticketId}`, { params: token ? { token } : undefined }).then(r => r.data),
  sendMessage: (ticketId: number, content: string, token?: string) =>
    apiClient.post(`/support/tickets/${ticketId}/messages`, { content }, { params: token ? { token } : undefined }),
  sendMessageWithFile: (ticketId: number, file: File, content: string, token?: string) => {
    const form = new FormData();
    form.append('file', file);
    form.append('content', content);
    return apiClient.post(`/support/tickets/${ticketId}/messages/upload`, form, {
      params: token ? { token } : undefined,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  resolveAsUser: (ticketId: number, token?: string) =>
    apiClient.post(`/support/tickets/${ticketId}/resolve`, { as: 'user' }, { params: token ? { token } : undefined }),

  // Admin
  listAdminTickets: (params?: { status?: string; search?: string; skip?: number; limit?: number }) =>
    apiClient.get(`/admin/support/tickets`, { params }).then(r => r.data),
  getAdminTicket: (ticketId: number) =>
    apiClient.get(`/admin/support/tickets/${ticketId}`).then(r => r.data),
  adminSendMessage: (ticketId: number, content: string) =>
    apiClient.post(`/admin/support/tickets/${ticketId}/messages`, { content }),
  adminSendMessageWithFile: (ticketId: number, file: File, content: string) => {
    const form = new FormData();
    form.append('file', file);
    form.append('content', content);
    return apiClient.post(`/admin/support/tickets/${ticketId}/messages/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  resolveAsAdmin: (ticketId: number) =>
    apiClient.post(`/admin/support/tickets/${ticketId}/resolve`),
  closeTicket: (ticketId: number) =>
    apiClient.post(`/admin/support/tickets/${ticketId}/close`),
};


